import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { appStrings } from '@backrs_ui/common-ui/src/assets/appStrings';
import { Box, Typography } from '@mui/material';
import { blueTextStyle, howToApplyHeaderStyle, unorderedListStyle } from './styles';
var _a = appStrings.modules.nugget.scholarship, HOW_TO_APPLY_STRINGS = _a.HOW_TO_APPLY_STRINGS, SECTION_TITLES = _a.SECTION_TITLES;
export function HowToApply(_a) {
    var scholarshipInfo = _a.scholarshipInfo;
    return (_jsxs(Box, { children: [_jsx(Typography, { variant: "h4", sx: howToApplyHeaderStyle, children: SECTION_TITLES.howToApply }), renderApplicationRequirements(scholarshipInfo.application_requirements), renderApplicationSubmission(scholarshipInfo.application_submission_method, scholarshipInfo.application_submission_destination), renderDeadlines(scholarshipInfo.submission_start_date, scholarshipInfo.submission_deadline_priority, scholarshipInfo.submission_deadline), renderApplicationFee(scholarshipInfo.application_fee), renderContactInformation(scholarshipInfo.contact_name, scholarshipInfo.contact_details, scholarshipInfo.contact_address)] }));
}
function renderApplicationRequirements(applicationRequirements) {
    if (!applicationRequirements) {
        return null;
    }
    var requirements = applicationRequirements.split('|').map(function (req) { return _jsx("li", { children: req }, req); });
    return (_jsxs(Typography, { variant: "body1", sx: blueTextStyle, children: [SECTION_TITLES.applicationRequirements, _jsx("ul", { style: unorderedListStyle, children: requirements })] }));
}
function truncateText(text, maxLength) {
    if (!text)
        return null;
    if (text.length <= maxLength)
        return text;
    return text.substring(0, maxLength - 3) + '...';
}
function renderApplicationSubmission(submissionMethod, submissionDestination) {
    if (!submissionMethod) {
        return null;
    }
    var isEmail = submissionDestination && submissionDestination.includes('@');
    var truncatedText = truncateText(submissionDestination, 70);
    var submissionLink = submissionDestination ? (_jsx("a", { href: isEmail ? "mailto:".concat(submissionDestination) : submissionDestination, target: "_blank", rel: "noopener noreferrer", children: truncatedText })) : null;
    return (_jsxs(Typography, { variant: "body1", sx: blueTextStyle, children: [SECTION_TITLES.applicationSubmission, _jsx("ul", { style: unorderedListStyle, children: _jsxs("li", { children: [submissionMethod, submissionLink ? _jsxs(_Fragment, { children: [": ", submissionLink] }) : ''] }) })] }));
}
function renderDeadlines(startDate, priorityDeadline, finalDeadline) {
    if (!startDate && !priorityDeadline && !finalDeadline) {
        return null;
    }
    var deadlines = [
        startDate && "".concat(HOW_TO_APPLY_STRINGS.SUBMISSION_START, " ").concat(startDate),
        finalDeadline && "".concat(HOW_TO_APPLY_STRINGS.SUBMISSION_DEADLINE, " ").concat(finalDeadline),
    ].filter(Boolean);
    return (_jsxs(Typography, { variant: "body1", sx: blueTextStyle, children: [SECTION_TITLES.applicationDates, _jsx("ul", { style: unorderedListStyle, children: deadlines.map(function (deadline) { return (_jsx("li", { children: deadline }, deadline)); }) })] }));
}
function renderApplicationFee(applicationFee) {
    if (!applicationFee) {
        return null;
    }
    return (_jsxs(Typography, { variant: "body1", sx: blueTextStyle, children: [SECTION_TITLES.applicationFee, _jsx("ul", { style: unorderedListStyle, children: _jsxs("li", { children: ["$", applicationFee] }) })] }));
}
function renderContactInformation(contactName, contactDetails, contactAddress) {
    if (!contactName && !contactDetails && !contactAddress) {
        return null;
    }
    var detailsList = [];
    if (contactDetails) {
        detailsList.push.apply(detailsList, contactDetails.split(';').map(function (detail) { return _jsx("li", { children: detail }, detail); }));
    }
    if (contactAddress) {
        detailsList.push(_jsx("li", { children: contactAddress }, "address"));
    }
    return (_jsxs(Typography, { variant: "body1", sx: blueTextStyle, children: [contactName || HOW_TO_APPLY_STRINGS.CONTACT, detailsList.length > 0 && _jsx("ul", { style: unorderedListStyle, children: detailsList })] }));
}
